import { render, staticRenderFns } from "./payApproval.vue?vue&type=template&id=2857bf0b&scoped=true&"
import script from "./payApproval.vue?vue&type=script&lang=js&"
export * from "./payApproval.vue?vue&type=script&lang=js&"
import style0 from "./payApproval.vue?vue&type=style&index=0&id=2857bf0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2857bf0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2857bf0b')) {
      api.createRecord('2857bf0b', component.options)
    } else {
      api.reload('2857bf0b', component.options)
    }
    module.hot.accept("./payApproval.vue?vue&type=template&id=2857bf0b&scoped=true&", function () {
      api.rerender('2857bf0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/payApproval.vue"
export default component.exports